import { addNotificationToApp, NotificationType } from './NotificationsActions';
import { PersonId } from '../types/api/primaryKeys/PrimaryKey';
import { ReduxDispatch } from '../types/redux/ReduxDispatch';
import * as Api from '../apiCalls/divisions/divisionApiCalls';
import { DivisionDetail } from '../types/api/divisions/DivisionDetail';

export enum DivisionActionTypes {
    FETCH_DIVISIONS = "FETCH_DIVISIONS",
    FETCH_DIVISIONS_SUCCESS = "FETCH_DIVISIONS_SUCCESS",
    FETCH_DIVISIONS_FAILURE = "FETCH_DIVISIONS_FAILURE"
}

export type DivisionAction =
    | ReturnType<typeof requestFetchDivisions>
    | ReturnType<typeof requestFetchDivisionsSuccess>
    | ReturnType<typeof requestFetchDivisionsFailure>;


function requestFetchDivisions(){
    return {
        type: DivisionActionTypes.FETCH_DIVISIONS
    } as const;
}

function requestFetchDivisionsSuccess(divisions: readonly DivisionDetail[]) {
    return {
        type: DivisionActionTypes.FETCH_DIVISIONS_SUCCESS,
        payload: divisions
    } as const;
}

function requestFetchDivisionsFailure(error: unknown) {
    return {
        type: DivisionActionTypes.FETCH_DIVISIONS_FAILURE,
        payload: error
    } as const;
}

export function fetchDivisions(personId: PersonId) {
    return async (dispatch: ReduxDispatch) => {
        dispatch(requestFetchDivisions());

        try {
            const json = await Api.getDivisionsForPerson(personId);
            dispatch(requestFetchDivisionsSuccess(json));
            return json;
        }
        catch (err) {
            dispatch(requestFetchDivisionsFailure(err));
            dispatch(addNotificationToApp("Failed To Get Division Details", NotificationType.Error));
        }
    };
}